import { Injectable } from "@angular/core";
import { ReplaySubject, Subject } from "rxjs";
import { BalanceModel } from "src/app/models/balance-model";
import { CustomerModel } from "src/app/models/customer-model";
import { isUndefined } from "../codeUtils";
import { ConfigService } from "../config/config.service";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { EventsService } from "../event/event.service";

@Injectable({
	providedIn: 'root'
})

export class AccountBalanceService {

	public accountBalances: any;
	public balanceSubject: Subject<BalanceModel>;
	public balance: any;
	public customer: CustomerModel;
	public startingBalance: any;
	public showBalance: boolean = true;

	constructor(
		public config: ConfigService,
		public userSession: UserSessionService,
		public webservices: WebservicesService,
		private events: EventsService,
	) {
		this.balanceSubject = new ReplaySubject(1);

		this.userSession.getCustomer().subscribe((customer) => {
			if (customer) {
				this.customer = customer;
				this.updateBalance();
			}
		});

		this.events.subscribe("event:balanceState", data => {
			this.showBalance = data?.show;

			if (data?.code === 'IN_GAME') {
				this.showBalance = false;
			}
		});
	}

	public updateBalance(params: any = {}) {

		const customerID = this.customer?.customerId;
		const sessionToken = this.userSession.getSessionToken()

		const obj: any = {
			customer_id: customerID,
			session_token: sessionToken,
		}

		if (!isUndefined(params.check_over_limit) && params.check_over_limit == 1) {
			obj.check_over_limit = 1;
		}

		this.webservices.get('customer/get-balance', obj).subscribe((response: any) => {
			if (!!response.result && response.payload) this.setBalance(response.payload);
		});

	}

	public reloadBalance(): any {
		const customerID = this.customer?.customerId;
		const sessionToken = this.userSession.getSessionToken()

		let obj: any = {
			customer_id: customerID,
			session_token: sessionToken,
		}

		return this.webservices.get('customer/get-balance', obj);
	}

	public setBalance(balance) {
		const config = this.config.getConfig();
		let balanceModel = new BalanceModel(balance, config);
		this.balance = balanceModel;
		this.startingBalance = this.balance[this.balance["DEFAULT_CURRENCY"]].availableBalance;
		this.balanceSubject.next(balanceModel);
	}

	public getBalance() {
		return this.balanceSubject;
	}

	public getDefaultCurrency() {
		return this.config.getConfig().DEFAULT_CURRENCY;
	}

	public updateBalanceFromNotification(notification) {
		if (notification["parametersMap"] != null && notification["parametersMap"].currency == "USD") {
			this.balance["USD"].total = notification['customField1'];
			this.balance["USD"].amount = notification['parametersMap'].amount;
			this.balance["USD"].amountReserved = notification['parametersMap'].amountReserved;
			this.balance["USD"].restrictedBalance = notification['parametersMap'].restrictedBalance;
			//this.balance["USD"].availableBalance =  notification['parametersMap'].availableBalance - notification['parametersMap'].restrictedBalance;
			this.balance["USD"].availableBalance = notification['parametersMap']?.availableBalance;
		}

		if (notification["parametersMap"] != null && notification["parametersMap"].currency == "CAD") {
			this.balance["CAD"].total = notification['customField1'];
			this.balance["CAD"].amount = notification['parametersMap'].amount;
			this.balance["CAD"].amountReserved = notification['parametersMap'].amountReserved;
			this.balance["CAD"].restrictedBalance = notification['parametersMap'].restrictedBalance;
			// webservice availableBalance is availableBalance - restrictedBalance
			this.balance["CAD"].availableBalance = notification['parametersMap'].availableBalance - notification['parametersMap'].restrictedBalance;
		}


		if (notification["parametersMap"] != null && notification["parametersMap"].currency == "MFREESPIN") {
			this.balance["MFREESPIN"].total = ~~notification["parametersMap"].amount;
			this.balance["MFREESPIN"].availableBalance = ~~notification["parametersMap"].amount;
		}

		if (notification["parametersMap"] != null && notification["parametersMap"].currency == "PLAY") {
			this.balance["PLAY"].total = ~~notification["parametersMap"].amount;
			this.balance["PLAY"].availableBalance = ~~notification["parametersMap"].amount;
		}

		this.balanceSubject.next(this.balance);
	}

	public callGetQualification(context, skip?) {
		let obj: any = {
			customer_id: this.customer?.customerId,
			session_token: this.userSession.sessionToken,
			context: context,
			skin_code: 'mohegansun',
			//skip: skip,
		};

		return this.webservices.post('customer/qualification', obj);
	}

	public getAccountBalanceLocks() {
		let obj: any = {
			customer_id: this.customer?.customerId,
			session_token: this.userSession.sessionToken,
		};
		return this.webservices.get('customer/get-account-balance-locks', obj);

		// Stub Response
		// return of(JSON.parse(`{
		// 	"result": 1,
		// 	"payload": [
		// 		{
		// 			"id": 59,
		// 			"amount": 10.00,
		// 			"reasonForLock": "PAYOUT",
		// 			"creationDate": "2014-09-02 15:30:42"
		// 		},
		// 		{
		// 			"id": 59,
		// 			"amount": 20.00,
		// 			"reasonForLock": "BIG_WIN",
		// 			"creationDate": "2014-09-02 15:30:42"
		// 		}

		// 	]
		// }`));
	}

}
